import { useMemo } from 'react';
import { usePortfolioDashboard } from './PortfolioDashboardContext';
import { PortfolioMetricCard } from './PortfolioMetricCard';
import { getPortfolioMetricDefinitions } from './portfolioDashboardUtilities';

/** @param {{ portfolioMetrics: import('./portfolioDashboard.types').PortfolioMetrics, currency: string }} props */
export const PortfolioMetrics = function PortfolioMetrics({ portfolioMetrics, currency }) {
    const { period } = usePortfolioDashboard();
    const metricDefinitions = useMemo(() => getPortfolioMetricDefinitions(period), [period]);

    return (
        <div className="grid mb-3">
            {metricDefinitions.map((metricDefinition) => (
                <PortfolioMetricCard
                    key={metricDefinition.metricKey}
                    metricDefinition={metricDefinition}
                    metric={portfolioMetrics[metricDefinition.metricKey]}
                    currency={currency}
                />
            ))}
        </div>
    );
};
